// Headless UI driver — same contract as src/ui/index.ts initUI but renders
// nothing. Registers no-op handlers for every UI intent in INTENTS so that
// non-UI dispatches don't silently no-op.

import { INTENTS } from '../store/intents';
import type { IntentName } from '../store/intents';
import type { Store } from '../store/store';
import type { State } from '../store/schema';
import type { ViewerContext } from '../app/context';

const UI_INTENT_PREFIX = 'ui:';

export interface UiHandle {
    dispose: () => void;
}

export function initUI(store: Store<State>, viewer: ViewerContext, _deps?: unknown): UiHandle {
    const debug = !!(viewer && viewer.sceneMeta && viewer.sceneMeta.debugEnabled);
    const offs: Array<() => void> = [];

    for (const name of Object.values(INTENTS)) {
        if (!name.startsWith(UI_INTENT_PREFIX)) continue;
        offs.push(store.onIntent(name as IntentName, (payload: unknown) => {
            if (debug) console.debug('[headless ui] intent', name, payload);
        }));
    }

    if (debug) {
        offs.push(store.subscribe('field.metadata', () => console.debug('[headless ui] field.metadata changed')));
        offs.push(store.subscribe('selection', () => console.debug('[headless ui] selection changed')));
    }

    return {
        dispose() {
            offs.forEach((off) => { try { off(); } catch { /* swallow */ } });
        },
    };
}
